import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import EnviarMensagem from '../pages/settaServicos/enviarMensagem';
import InserirJustificativa from '../pages/settaServicos/inserirJustificativa';
import ValidarFatura from '../pages/settaServicos/validarFatura';
import ValidarSerasa from '../pages/settaServicos/validarSerasa';

const RouteSettaServicos = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='SS'/>}>
                <Route path='inserirJustificativa' element={<InserirJustificativa/>}/>
                <Route path='validarFatura' element={<ValidarFatura/>}/>
                <Route path='enviarMensagem' element={<EnviarMensagem/>}/>
                <Route path='validarSerasa' element={<ValidarSerasa/>}/>
            </Route>
        </Routes>
    );
};

export default RouteSettaServicos;
